import { AfterViewChecked, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, viewChild } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],

    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FooterComponent implements AfterViewChecked {
    nonSA360Contact = environment.nonSA360Contact;
    teconsent = viewChild<ElementRef>('teconsent');

    ngAfterViewChecked(): void {
        // for ADA compliance
        const element = this.teconsent();
        if (element?.nativeElement && element.nativeElement.getAttribute('role') !== 'none') {
            element.nativeElement.setAttribute('role', 'none');
        }
    }
}